var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExactMatch = function SvgExactMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.572.648 6.32 2.39l-2.702.105a.7.7 0 0 0-.637.478l-.92 2.757L.258 7.536a.7.7 0 0 0-.105.855l1.324 2.208-.444 2.664a.7.7 0 0 0 .412.758l2.602 1.127 1.159 2.413a.7.7 0 0 0 .835.367L9 17.024l2.954.901a.7.7 0 0 0 .848-.394l.968-2.264 2.793-1.248a.7.7 0 0 0 .405-.754l-.445-2.666 1.325-2.208a.7.7 0 0 0-.105-.855L15.937 5.73l-.919-2.757a.7.7 0 0 0-.637-.478l-2.702-.105L9.43.648a.7.7 0 0 0-.857 0ZM5.853 9.646 7.5 11.292l4.646-4.646a.5.5 0 1 1 .707.707L7.5 12.707l-2.354-2.354a.5.5 0 0 1 .707-.707Z",
    fill: "#4D33DE"
  })));
};
export default SvgExactMatch;